module.exports = __webpack_public_path__ + "img/bg_question_des_3.1e5ba71e.jpg";